const minimumFractionDigits = 2;
export function showSalary(salary, salMin, salMax) {
  if (checkDecimal(salMin, salMax)) {
    return salary.toLocaleString(undefined, { minimumFractionDigits });
  } else {
    return salary.toLocaleString();
  }
}

const checkDecimal = (salMin, salarymax) => {
  let decSal = String(salMin).split(".");
  let decSal2 = String(salarymax).split(".");
  if (decSal2.length > 1 || decSal.length > 1) {
    return true;
  }
  return false;
};
